import React, { useContext, useEffect } from "react";
import classes from "./Payment.module.scss";
import InputRadio from "../../../../UI/Inputs/InputRadio/InputRadio";
import { useDispatch, useSelector } from "react-redux";
import Pix from "../../../../../assets/images/pix.svg";
import creditCardIcon from "../../../../../assets/images/creditCardIcon.svg";
import SystemContext from "../../../../../context/SystemContext";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

const Payment = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const payload = useSelector((state) => state.purchase);
  const isBrazil =
    payload &&
    payload.PostData &&
    payload.PostData.invoice_info &&
    payload.PostData.invoice_info.country === "Brasil";
  const PaymentMethod = searchParams.get("paymentMethod");

  const {
    setPurchaseInfo,
    setErrorRule,
    initialErrorRule,
    initialError,
    setCheckError,
    changePropertyUrl
  } = useContext(SystemContext);

  useEffect(() => {
    if (PaymentMethod) {
      if (PaymentMethod == "creditcard") {
        handleChangeCreditCard();
      } else if (PaymentMethod == "pix") {
        handleChangeCreditPix();
        console.log("PIX selected via URL param");
      }
    }
    setErrorRule(initialErrorRule);
    setCheckError(initialError);
  }, [PaymentMethod]);

  useEffect(() => {
      changePropertyUrl("",{etapa:"pagamento",metodoPagamento:(payload.planInfo?.payment_method == "pix" || PaymentMethod=="pix") ? "pix" : "cartao"});
  }, [])

  const handleChangeCreditCard = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "CreditCard",
      },
      planInfo: {
        payment_method: "creditcard",
      },
    });
  };

  const handleChangeCreditPix = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "DescPix",
      },
      planInfo: {
        payment_method: "pix",
      },
    });
    setPurchaseInfo((prevState) => ({
      ...prevState,
      MethodChosen: "DescPix",
      SuccessState: "processing",
    }));
  };

  return (
    <div className={classes.PaymentArea}>
      <div className={classes.Title}>
        {t("purchase.choose_the_payment_method")}
      </div>
      {(!PaymentMethod || PaymentMethod == "creditcard") && (
        <InputRadio
          slotProps={{
            input: {
              "data-testid": "payment_creditCard_option_input",
            },
          }}
          type="radio"
          image={creditCardIcon}
          // defaultChecked={true}
          className={classes.CheckboxLeft}
          value="CreditCard"
          label={t("purchase.credit_card")}
          name="radio-buttons"
          checked={payload.purchase.step === "CreditCard"}
          onClick={() => handleChangeCreditCard()}
        />
      )}
      {isBrazil && (!PaymentMethod || PaymentMethod == "pix") && (
        <InputRadio
          slotProps={{
            input: {
              "data-testid": "payment_pix_option_input",
            },
          }}
          type="radio"
          image={Pix}
          className={classes.CheckboxRight}
          value="DescPix"
          label={t("purchase.pix")}
          name="radio-buttons"
          checked={payload.purchase.step === "DescPix"}
          onClick={() => handleChangeCreditPix()}
        />
      )}
    </div>
  );
};

export default Payment;
